<template>


    <div>
        <div class="h100"></div>
        <el-card :class="webW?'w_web':'w_phone'">
            <div v-if="webW" slot="header">
                <span>提示信息</span>
            </div>
            <div>
                <h3 class="center">帖子发布成功</h3>
                <p class="tipcsuc  ">接下来您要去哪儿？返回主页面请选择“返回上一页按钮”，或者选择编辑、查看按钮操作您刚发布的帖子。</p>
                <div class="row center">

                    <div class="col-sm-4">
                        <div class=" hx "></div>

                            <el-button @click="edit()" icon="el-icon-edit" type="warning" round plain>重新编辑</el-button>

                    </div>
                    <div class="col-sm-4">
                        <div class=" hx "></div>

                            <el-button @click="goForumDetail()" icon="el-icon-view" type="warning" round plain>查看详情</el-button>

                    </div>
                    <div class="col-sm-4">
                        <div class=" hx "></div>

                            <el-button @click="goForum()" icon="el-icon-back" round plain>返回上一页</el-button>

                    </div>
                </div>
            </div>
            <div :class="webW?'h100':'h50'"></div>

        </el-card>

    </div>

</template>

<script>


    import {getWindowWidth,dealResult,} from "../../../api/common";
    import PubSub from "pubsub-js";
    import {forumtop, } from '../../../api';

    export default {
        name: "ReleaseForumSucc",
        components: {},

        data() {
            return {
                webW: true,

                typeId: 0,
                forumId: 0,
                //置顶信息
                TopData: [],
                lander: {},
                query: {
                },


            }
        },

        methods: {
            edit(){
                sessionStorage.managerEditForumFromIndex="1";
                this.$router.replace("ForumDetail?id="+this.forumId+"&goPosition=top");
            },
            goForum(){
                this.$router.replace("Forum?typeId="+this.typeId+"&releaseSuccReturnflush=need");
                PubSub.publish('forumDataListForTop', null);
                this.getForumTop();
            },
            goForumDetail() {
                this.$router.replace("ForumDetail?id=" + this.forumId + "&goPosition=top");
            },
              //获取置顶的帖子
            getForumTop() {
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.typeId;
                forumtop(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        let li = res.data.obj.list;
                        if (li.length == 0) {
                            this.tableDataFinish = true;
                            return;
                        }
                        for (let i = 0; i < li.length; i++) {
                            li[i].hidden = true;
                            li[i].showComments = false;
                            li[i].commentli = [];
                            li[i].commentliLoading = false;
                            li[i].iscollect = "0";
                            li[i].ishit = "0";
                            li[i].voteItemli = [];
                            li[i].ivote = '0';
                            li[i].myvoteDx = '';
                            li[i].myvoteMx = [];
                            li[i].nowvideo = {
                                vindex: 0,
                                isshow: '0'
                            };
                        }
                        this.TopData = this.TopData.concat(li);
                        PubSub.publish('forumDataListForNewPub', li);
                    } else {
    
                        this.$message.error(res.data.msg)
                    }
                })
            },

        }, mounted() {
            this.webW = getWindowWidth() >= 1000 ? true : false;
            this.lander = JSON.parse(this.$store.state.logininfo);

            if (this.$route.query.typeId == undefined) this.typeId = 0;
            else this.typeId = this.$route.query.typeId;


            if (this.$route.query.forumId == undefined) this.forumId = 0;
            else this.forumId = this.$route.query.forumId;
        },
        watch: {
            $route: function (value) {

                if (value.query.typeId != undefined  ) {
                    this.typeId = value.query.typeId
                }
                if (value.query.forumId != undefined   ) {
                    this.forumId = value.query.forumId
                }

            }
        },
    };
</script>

<style scoped>
    .w_web {
        width: 500px;
        margin: auto auto;
    }

    .w_phone {
        width: 90%;
        margin-left: 5%
    }

    .h100 {
        height: 100px
    }

    .h50 {
        height: 50px;
    }

    .tipcsuc {
        color: #666;
        font-size: 12px;
        text-indent: 2em;
        margin: 30px 0;
    }

    .hx {
        height: 20px;
    }

</style>
